import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Socialize from './pages/Socialize';
import Preloader from './components/Preloader'; // Import Preloader component

import MainAbout from './pages/MainAbout';
import AboutSkill from './pages/Aboutskill';
import AboutPage from './pages/AboutPage';

const App = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if the preloader has already been displayed
    const preloaderDisplayed = localStorage.getItem('preloaderDisplayed');

    if (!preloaderDisplayed) {
      // Set the loading state to false after 5 seconds if preloader hasn't been displayed
      const timer = setTimeout(() => {
        setLoading(false);
        localStorage.setItem('preloaderDisplayed', 'true');
      }, 5000);

      // Cleanup the timer if the component unmounts before 5 seconds
      return () => clearTimeout(timer);
    } else {
      // Skip showing the preloader if it has already been displayed
      setLoading(false);
    }
  }, []);

  if (loading) {
    return <Preloader />;
  }

  return (
    <Router>
      <div className="min-h-screen">
        <HeaderWithConditionalRender />
        <main className="rst pt-20">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/AboutPage" element={<AboutPage />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/socialize" element={<Socialize />} />
            <Route path="/mainabout" element={<MainAbout />} />
            <Route path="/Aboutskill" element={<AboutSkill />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
};

// Component to conditionally render the Header
const HeaderWithConditionalRender = () => {
  const location = useLocation();
  const showHeader = location.pathname !== '/socialize' && location.pathname !== '/about' && location.pathname !== '/mainabout';
  
  return showHeader ? <Header /> : null;
};

export default App;
